import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import AdCard from './AdCard';
import { getRecentlyViewedStripIds } from '../utils/recentlyViewed';
import './RecentlyViewedList.css';

// Renders the localStorage-backed "recently viewed" list as a horizontal strip (capped, see STRIP_LIMIT).
// excludeId keeps the ad currently open (if any) out of its own widget.
const RecentlyViewedList = ({ excludeId, title = 'Недавно просмотренные' }) => {
    const [ads, setAds] = useState([]);

    useEffect(() => {
        const ids = getRecentlyViewedStripIds(excludeId);
        if (ids.length === 0) { setAds([]); return; }

        api.get('/ads/by-ids', { params: { ids: ids.join(',') } })
            .then(({ data }) => {
                const byId = new Map(data.map(ad => [ad.id, ad]));
                // Backend drops ids for unpublished/removed ads - keep only what came back, in order
                setAds(ids.map(id => byId.get(id)).filter(Boolean));
            })
            .catch(() => setAds([]));
    }, [excludeId]);

    if (ads.length === 0) return null;

    return (
        <div className="recently-viewed">
            <Link to="/recently-viewed" className="recently-viewed__title-link">
                <h2 className="recently-viewed__title">{title}</h2>
            </Link>
            <div className="recently-viewed__list">
                {ads.map(ad => (
                    <div className="recently-viewed__item" key={ad.id}>
                        <AdCard ad={ad} view="grid" listName="recently_viewed" />
                    </div>
                ))}
                <Link to="/recently-viewed" className="recently-viewed__item recently-viewed__more">
                    <span>Смотреть все</span>
                </Link>
            </div>
        </div>
    );
};

export default RecentlyViewedList;
